export default __webpack_public_path__ + "static/media/muthJarSpringHoney.20ad6fa9.jpg";